import './src/styles/bootstrap.min.css';
import './src/styles/global.scss';

require('typeface-open-sans');
require('typeface-source-serif-pro');
require('typeface-shadows-into-light');
